"use client"

import { ArrowUpRight } from "lucide-react"

const socialLinks = [
  { label: "EMAIL", value: "hello@futovia.com", href: "mailto:hello@futovia.com" },
  { label: "X", value: "@Futoviadotcom", href: "https://x.com/Futoviadotcom" },
  { label: "GITHUB", value: "/futovia", href: "https://github.com/futovia" },
  { label: "LINKEDIN", value: "/futovia-pte-ltd", href: "https://www.linkedin.com/company/futovia-pte-ltd" },
  { label: "INSTAGRAM", value: "@futovia", href: "https://www.instagram.com/futovia/" },
  { label: "YOUTUBE", value: "@Futovia", href: "https://www.youtube.com/@Futovia" },
]

export function Footer() {
  return (
    <footer className="mt-32 border-t border-border/30 bg-background px-6 pb-12 pt-16 md:px-12">
      {/* Tech data decoration row */}
      <div className="mb-16 grid grid-cols-2 gap-4 font-mono text-[10px] text-muted-foreground/60 sm:grid-cols-3 lg:grid-cols-6">
        {/* Binary/hex data - FUTOVIA encoded */}
        <div className="space-y-1 lg:col-span-2">
          <div>01000110 01010101 01010100 01001111</div>
          <div>01010110 01001001 01000001</div>
          <div>46 55 54 4F 56 49 41</div>
          <div>-----</div>
          <div>SYSTEM.BUILD: 2026.01</div>
          <div>FTV_CORE_V1.0.0</div>
        </div>

        {/* Coordinates */}
        <div className="space-y-1 lg:col-span-2">
          <div>1.2738° N, 103.8333° E</div>
          <div>THE SIMULATION</div>
          <div>DEPTH: -341M</div>
          <div>-----</div>
          <div>NODE_ID: SG-01-FTV</div>
          <div>UPTIME: 99.97%</div>
        </div>

        {/* Matrix references */}
        <div className="hidden space-y-1 sm:block lg:col-span-2">
          <div>WAKE_UP_NEO...</div>
          <div>FOLLOW_THE_WHITE_RABBIT</div>
          <div>KNOCK_KNOCK</div>
          <div>-----</div>
          <div>MASS: 9.109×10⁻³¹ kg</div>
          <div>ENTROPY: HIGH</div>
        </div>

      </div>

      {/* Social links grid */}
      <div>
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {socialLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group flex flex-col gap-1"
            >
              <div className="flex items-center gap-2">
                <span className="font-mono text-xs font-medium text-foreground transition-colors group-hover:text-primary">
                  {link.label}
                </span>
                <ArrowUpRight className="h-3 w-3 text-muted-foreground transition-colors group-hover:text-primary" />
              </div>
              <span className="font-mono text-[10px] text-muted-foreground/60">
                {link.value}
              </span>
            </a>
          ))}
        </div>
      </div>

      {/* Bottom copyright */}
      <div className="mt-16">
        <div className="flex flex-wrap items-center justify-between gap-4 border-t border-border/30 pt-8 font-mono text-[10px] text-muted-foreground/40">
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>© 2026 FUTOVIA. ALL RIGHTS RESERVED.</span>
            <span>FUTOVIA PTE. LTD.</span>
            <span>UEN: 202210487K</span>
            <a href="/privacy" className="transition-colors hover:text-primary">PRIVACY</a>
          </div>
          <span>HANDCRAFTED BY FUTOVIA</span>
        </div>
      </div>
    </footer>
  )
}
